import React from 'react';
import Carousel from 'react-elastic-carousel';
import useEntries from '../Common/useEntries';
import ClientList from './ClientList';
import { Section, SectionHeading, LoadingState } from '../Common/PageLayout';

const breakPoints = [
    { width: 1, itemsToShow: 2 },
    { width: 550, itemsToShow: 3 },
    { width: 768, itemsToShow: 4 },
    { width: 1200, itemsToShow: 5 },
];

/** Homepage strip of development partners and partner institutions. */
export default function Partners() {
    const { items, loading } = useEntries({
        content_type: 'client-partners',
        limit: 60,
    });

    if (!loading && items.length === 0) return null;

    return (
        <Section tone="muted" bordered>
            <SectionHeading
                overline="Working together"
                title="Our partners"
                description="The Ministry works with development partners, international financial institutions and other government bodies to strengthen public financial management."
                action={{ label: 'About our partnerships', to: '/partners' }}
                rule
            />

            {loading ? (
                <LoadingState label="Loading partners" />
            ) : (
                <Carousel
                    isRTL={false}
                    enableAutoPlay
                    autoPlaySpeed={3500}
                    breakPoints={breakPoints}
                    pagination={false}
                    itemPadding={[0, 8]}
                >
                    {items.map((entry) => (
                        <ClientList key={entry.sys.id} menus={entry} />
                    ))}
                </Carousel>
            )}
        </Section>
    );
}
